function formatFullAddress(parts: {
  address?: string | null;
  city?: string | null;
  postal_code?: string | null;
  country?: string | null;
}): string {
  return [parts.address, parts.city, parts.postal_code, parts.country]
    .map((p) => (p ?? "").trim())
    .filter(Boolean)
    .join(", ");
}

export type AddressDetailFieldNames = {
  street: string;
  city: string;
  postalCode: string;
  province: string;
  country: string;
};

export function formatAddressFromFieldValues(
  fields: AddressDetailFieldNames,
  values: Record<string, string | undefined>,
): string {
  return formatFullAddress({
    address: values[fields.street],
    city: values[fields.city],
    postal_code: values[fields.postalCode],
    country: values[fields.country],
  });
}
